import { useEffect, useRef } from 'react';

// Default timeout: 15 minutes in milliseconds
const DEFAULT_TIMEOUT = 15 * 60 * 1000;

export const useSessionTimeout = (
  isAuthenticated: boolean,
  logout: () => void,
  timeoutMs: number = DEFAULT_TIMEOUT
) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    
    if (isAuthenticated) {
      timerRef.current = setTimeout(() => {
        console.log('Session expired due to inactivity. Logging out...');
        logout();
      }, timeoutMs);
    }
  };

  useEffect(() => {
    // Only track activity if the user is authenticated
    if (!isAuthenticated) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      return;
    }

    // Initialize timer
    resetTimer();

    // Events that indicate user activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

    const handleActivity = () => {
      resetTimer();
    };

    events.forEach((event) => {
      document.addEventListener(event, handleActivity, { passive: true });
    });

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      events.forEach((event) => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, [isAuthenticated, logout, timeoutMs]); // react-hooks/exhaustive-deps
};
